/* eslint-disable import/prefer-default-export */
export const TestProcessCaseOverrides = [
  {
    id: "c81d6f13-389b-4752-abd0-86c90c135799",
    override_reason: "lorem ipsum 1",
    applied: true,
    created_at: "2021-03-29T09:11:50.233137Z",
    case: {
      case_id: "99732c2b-fb00-49ce-b941-ad03144c32eb",
      client_case_id: "MORR:009341800029707",
    },
    rule: {
      rule_name: "kyc_risk_greater_than_threshold",
    },
  },
  {
    id: "68ffbc28-54be-4c90-9641-c28929c64cd3",
    override_reason: "lorem ipsum 2",
    applied: false,
    created_at: "2021-03-29T09:12:34.010851Z",
    case: {
      case_id: "99732c2b-fb00-49ce-b941-ad03144c32eb",
      client_case_id: "MORR:009341800029707",
    },
    rule: {
      rule_name: "kyc_risk_greater_than_threshold",
    },
  },
  {
    id: "78bf87d9-eb42-425d-98e1-455c278c5b86",
    override_reason: "lorem ipsum 3",
    applied: true,
    created_at: "2021-03-29T09:14:54.201573Z",
    case: {
      case_id: "99732c2b-fb00-49ce-b941-ad03144c32eb",
      client_case_id: "MORR:009341800029707",
    },
    rule: {
      rule_name: "kyc_risk_greater_than_threshold",
    },
  },
  {
    id: "c81d6f13-389b-4752-abd0-86c90c135799",
    override_reason: "lorem ipsum 4",
    applied: true,
    created_at: "2021-03-29T09:11:50.233137Z",
    case: {
      case_id: "99732c2b-fb00-49ce-b941-ad03144c32eb",
      client_case_id: "MORR:009341800029706",
    },
    rule: {
      rule_name: "kyc_risk_greater_than_threshold",
    },
  },
  {
    id: "68ffbc28-54be-4c90-9641-c28929c64cd3",
    override_reason: "lorem ipsum 5",
    applied: false,
    created_at: "2021-03-29T09:12:34.010851Z",
    case: {
      case_id: "99732c2b-fb00-49ce-b941-ad03144c32eb",
      client_case_id: "MORR:009341800029706",
    },
    rule: {
      rule_name: "No bankruptcy flag",
    },
  },
  {
    id: "78bf87d9-eb42-425d-98e1-455c278c5b86",
    override_reason: "lorem ipsum 6",
    applied: true,
    created_at: "2021-03-29T09:14:54.201573Z",
    case: {
      case_id: "99732c2b-fb00-49ce-b941-ad03144c32eb",
      client_case_id: "MORR:009341800029701",
    },
    rule: {
      rule_name: "No bankruptcy flag",
    },
  },
];
